  import '@babel/polyfill'
  import 'mutationobserver-shim'
  import Vue from 'vue'
  import { VueReCaptcha } from 'vue-recaptcha-v3'
  import './plugins/bootstrap-vue'
  import App from './App.vue'
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon'
  import { ValidationProvider, ValidationObserver,  extend} from 'vee-validate';
  import * as rules from "vee-validate/dist/rules";
  import Moment from 'vue-moment';
  import 'cross-fetch/polyfill'

  function isIEBrowser() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
  
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./))  // If Internet Explorer, return version number
    {
      return true;
    }
    return false;
  }

  if(isIEBrowser())
  {
    var appDiv = document.getElementById('app');
    appDiv.innerHTML = `
      <div style="margin: 0px 0px 0px 20px;">
        <h1 style="color:#808080;">Güncel olmayan bir tarayıcı kullanıyorsunuz.</h1>
        <p style="margin: 0px 0px 0px 5px;">www.cercev-e.com'u kullanabilmek için aşağıdaki güncel ve ücretsiz tarayıcılardan birini yükleyebilirsiniz.</p>
        <ul style="margin: 20px 0px 0px 20px;">
          <li style="margin-bottom:10px;"><a href="https://www.google.com.tr/intl/tr/chrome/"><img src="/images/chrome_ico.png"/> Google Chrome</a></li>
          <li style="margin-bottom:10px;"><a href="https://www.mozilla.org/tr/firefox/new/"><img src="/images/firefox_ico.png"/> Firefox</a></li>
          <li style="margin-bottom:10px;"><a href="https://www.microsoft.com/tr-tr/edge"><img src="/images/edge_ico.png"/> Microsoft Edge</a></li>
          <li style="margin-bottom:10px;"><a href="https://www.opera.com/tr/download"><img src="/images/opera_ico.png"/> Opera</a></li>
        </ul>
      </div>
    `;
  }
  else
  {
    Vue.config.productionTip = false
    Vue.use(VueReCaptcha, { siteKey: '6LfaFLgZAAAAAAsbjF55XFtC-3Br5fFpJ5L8SQTs' })
    Vue.component('v-icon', Icon)
    Vue.component('ValidationObserver', ValidationObserver);
    Vue.component('ValidationProvider', ValidationProvider);

    Object.keys(rules).forEach(rule => {
      extend(rule, rules[rule]);
    });

    Vue.use(Moment);

    new Vue({
      render: h => h(App),
    }).$mount('#app');
  }
